import { render, staticRenderFns } from "./DuplicatesManager.vue?vue&type=template&id=d0fa7d86"
import script from "./DuplicatesManager.vue?vue&type=script&lang=js"
export * from "./DuplicatesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports